<template>

    <m-edit1/>

    <m-nav-4 v-bind='{...{},...{}}' :style='""' class="nav-4 " ></m-nav-4><m-div v-bind='{...{},...{}}' :style='"background: var(--secondary);"' class="" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="p-0 mx-auto m-0 container" >
                <template #default>   <m-nav-2 v-bind='{...{"shoppingCart":false,"dashboardLink":"https:\/\/dash.tabibekhanevade.ir\/dashboard","AuthLink":{"name":"Login"}},...{}}' :style='""' class="" ></m-nav-2></template>
                </m-div></template>
                </m-div><m-nav-305 v-bind='{...{"shoppingCartToggleTo":null,"activeSms":false,"navDataToggle":"#nav-305-menu","menuPosition":"blog_footer","searchInput":"mSearchInput200"},...{}}' :style='""' class="" >
                <template #p-1>   </template>
                
                <template #p-2>   </template>
                
                <template #p-3>   </template>
                </m-nav-305><m-loading-3 v-bind='{...{},...{}}' :style='""' class="" ></m-loading-3><m-update-site-message-1 v-bind='{...{},...{}}' :style='""' class="" ></m-update-site-message-1><router-view name='site' v-bind='{...{},...{}}' :style='""' class='""' /><m-div v-bind='{...{},...{}}' :style='"\nbackground:  var(--secondary);\nbackground-image: url(\"https:\/\/api.salehinstz.ir\/storage\/assets\/Hexagon.svg\");\nbackground-repeat: no-repeat;\nbackground-size: cover;\n"' class="f100 py-5" >
                <template #default>   <m-footer-100 v-bind='{...{"menuPosition":"blog_footer","searchInput":"mSearchInput200"},...{}}' :style='""' class="f-100" ></m-footer-100></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mNav4 from '@moeinmdn/miw-alpha-components/src/package/Navs/Nav4'; import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mNav2 from '@moeinmdn/miw-alpha-components/src/package/Navs/Nav2/Nav2'; import mNav305 from '@moeinmdn/miw-alpha-components/src/package/Navs/Nav305/Nav305'; import mLoading3 from '@moeinmdn/miw-alpha-components/src/package/Loading/Loading3'; import mUpdateSiteMessage1 from '@moeinmdn/miw-alpha-components/src/package/UpdateSiteMessage/UpdateSiteMessage1'; import mFooter100 from '@moeinmdn/miw-alpha-components/src/package/Footers/Footer100/Footer100';

export default {
    name: 'HomeView',
    components: {mEdit1, mNav4,mDiv,mNav2,mNav305,mLoading3,mUpdateSiteMessage1,mFooter100 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
